import React from "react";
import PropTypes from "prop-types";
import { Button } from "elements/Button/Button";
import { Rating } from "components/reviews/Rating/Rating";
import { Price } from "../../Price/Price";
import { Image } from "blocks/Image/Image";

import "./ModelRangeCard.scss";

function AltText(sub, head, image) {
  let altText = sub + " " + head;
  if (image.includes("no-image") || image.includes("logo")) {
    altText = `Image for ${sub} ${head} coming soon`;
  }
  return altText;
};
    
export const ModelRangeCard = (props) => {

  const accessibleButtonLabel = `View full range of ${props.subHeading} ${props.heading}'s`;

  return (
  <div className="model-range-card">
    <header className="model-range-card__heading">
      <div className="model-range-card__titles">
        <h2 className="model-range-card__title">{props.heading}</h2>
        <h3 className="model-range-card__title model-range-card__title--brand">
          {props.subHeading}
        </h3>
      </div>
    </header>
    <section>
      <div className="model-range-card__image">
        <Button isPlain={true} onClick={props.onPrimaryButtonClick}>
          <Image src={props.image} alt={`${AltText(props.subHeading, props.heading, props.image)}`} width={525} />
        </Button>
      </div>
      <div className="model-range-card__row">
        <Price className="model-range-card__price" {...props.price} />
        <div className="model-range-card-sticker">
          <span className="model-range-card-sticker__text">{props.stickerText}</span>
        </div>
      </div>
      {props.showRating && (
        <div className="model-range-card__rating">
          <Rating
            rating={props.rating}
            ratingMeta={props.ratingMeta}
            ratingLogoSrc={props.reviewsLogoSrc}
          />
        </div>
      )}
      <div className="model-range-card__cta">
        <Button
          {...props.primaryButton}
          onClick={props.onPrimaryButtonClick}
          ariaLabel={accessibleButtonLabel}
        />
      </div>
    </section>
  </div>
)};

ModelRangeCard.propTypes = {
  subHeading: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  stickerText: PropTypes.string,
  rating: PropTypes.shape({
    value: PropTypes.number,
  }),
  price: PropTypes.object.isRequired,
  showRating: PropTypes.bool.isRequired,
  onPrimaryButtonClick: PropTypes.func.isRequired,
};
